export enum KeypointAnalysisStatusEnum {
  Normal = 'Normal',
  PotentiallyAbnormal = 'PotentiallyAbnormal',
  Abnormal = 'Abnormal'
}

export const allKeypointAnalysisStatuses = Object.keys(KeypointAnalysisStatusEnum);